// removed by extract-text-webpack-plugin
module.exports = {"ModalSafetyMessage":"ModalSafetyMessage__-loca-__3tCax","ButtonGroup":"ModalSafetyMessage__-loca-__3gcRu","Yes":"ModalSafetyMessage__-loca-__1wz_y","No":"ModalSafetyMessage__-loca-__3WLIq","Edit":"ModalSafetyMessage__-loca-__DRlAk","Delete":"ModalSafetyMessage__-loca-__1ocxI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/ModalSafetyMessage/ModalSafetyMessage.css
// module id = 194
// module chunks = 0